"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      Button = _ref.Button;

  var FullscreenCtaButton = /*#__PURE__*/function (_React$Component) {
    _inherits(FullscreenCtaButton, _React$Component);

    var _super = _createSuper(FullscreenCtaButton);

    function FullscreenCtaButton() {
      var _this;

      _classCallCheck(this, FullscreenCtaButton);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "renderButton", function () {
        var _this$props = _this.props,
            buttonProps = _this$props.buttonProps,
            onCtaClick = _this$props.onCtaClick;
        return /*#__PURE__*/_react["default"].createElement(Button, {
          text: buttonProps.text,
          clickHandler: onCtaClick,
          bgColor: buttonProps.bgColor,
          color: buttonProps.textColor,
          link: buttonProps.link,
          size: "small",
          noWrap: true
        });
      });

      return _this;
    }

    _createClass(FullscreenCtaButton, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            theme = _this$props2.theme,
            isDesktop = _this$props2.isDesktop;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: this.fullscreenCtaClass
        }, isDesktop && /*#__PURE__*/_react["default"].createElement("div", {
          className: theme.buttonContainer
        }, this.renderButton()), !isDesktop && this.renderButton());
      }
    }, {
      key: "fullscreenCtaClass",
      get: function get() {
        var _cn;

        var _this$props3 = this.props,
            theme = _this$props3.theme,
            ctaVisible = _this$props3.ctaVisible;
        return (0, _classnames["default"])(theme.fullscreenCta, (_cn = {}, _defineProperty(_cn, theme.active, ctaVisible), _defineProperty(_cn, theme.inactive, !ctaVisible), _cn));
      }
    }]);

    return FullscreenCtaButton;
  }(_react["default"].Component);

  FullscreenCtaButton.displayName = identifier;
  FullscreenCtaButton.propTypes = {
    theme: _propTypes["default"].object.isRequired,
    onCtaClick: _propTypes["default"].func.isRequired,
    buttonProps: _propTypes["default"].object.isRequired,
    ctaVisible: _propTypes["default"].bool.isRequired,
    isDesktop: _propTypes["default"].bool
  };
  return FullscreenCtaButton;
};

var _default = factory;
exports["default"] = _default;